import { render, staticRenderFns } from "./emission-component.vue?vue&type=template&id=014221d5"
import script from "./emission-component.vue?vue&type=script&lang=ts"
export * from "./emission-component.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./emission-component.vue?vue&type=style&index=0&id=014221d5&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports